module.exports = __webpack_public_path__ + "static/img/shaokao.6421158c.svg";